import { render } from "./FeedbackItem.vue?vue&type=template&id=258a1ada&scoped=true"
import script from "./FeedbackItem.vue?vue&type=script&lang=js"
export * from "./FeedbackItem.vue?vue&type=script&lang=js"

import "./FeedbackItem.vue?vue&type=style&index=0&id=258a1ada&lang=scss&scoped=true"

import exportComponent from "/home/deploy/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-258a1ada"]])

export default __exports__